import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isDisabled", "isInvalid", "isReadOnly", "isRequired"],
  _excluded2 = ["id", "disabled", "readOnly", "required", "isRequired", "isInvalid", "isReadOnly", "isDisabled", "onFocus", "onBlur"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useFormControlContext } from "./chunk-PXXQR4UW.mjs";

// src/use-form-control.ts
import { ariaAttr, callAllHandlers } from "@chakra-ui/shared-utils";
function useFormControl(props) {
  var _useFormControlProps = useFormControlProps(props),
    isDisabled = _useFormControlProps.isDisabled,
    isInvalid = _useFormControlProps.isInvalid,
    isReadOnly = _useFormControlProps.isReadOnly,
    isRequired = _useFormControlProps.isRequired,
    rest = _objectWithoutProperties(_useFormControlProps, _excluded);
  return _objectSpread(_objectSpread({}, rest), {}, {
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    "aria-invalid": ariaAttr(isInvalid),
    "aria-required": ariaAttr(isRequired),
    "aria-readonly": ariaAttr(isReadOnly)
  });
}
function useFormControlProps(props) {
  var _a, _b, _c;
  var field = useFormControlContext();
  var id = props.id,
    disabled = props.disabled,
    readOnly = props.readOnly,
    required = props.required,
    isRequired = props.isRequired,
    isInvalid = props.isInvalid,
    isReadOnly = props.isReadOnly,
    isDisabled = props.isDisabled,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    rest = _objectWithoutProperties(props, _excluded2);
  var labelIds = props["aria-describedby"] ? [props["aria-describedby"]] : [];
  if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) {
    labelIds.push(field.feedbackId);
  }
  if (field == null ? void 0 : field.hasHelpText) {
    labelIds.push(field.helpTextId);
  }
  return _objectSpread(_objectSpread({}, rest), {}, {
    "aria-describedby": labelIds.join(" ") || void 0,
    id: id != null ? id : field == null ? void 0 : field.id,
    isDisabled: (_a = disabled != null ? disabled : isDisabled) != null ? _a : field == null ? void 0 : field.isDisabled,
    isReadOnly: (_b = readOnly != null ? readOnly : isReadOnly) != null ? _b : field == null ? void 0 : field.isReadOnly,
    isRequired: (_c = required != null ? required : isRequired) != null ? _c : field == null ? void 0 : field.isRequired,
    isInvalid: isInvalid != null ? isInvalid : field == null ? void 0 : field.isInvalid,
    onFocus: callAllHandlers(field == null ? void 0 : field.onFocus, onFocus),
    onBlur: callAllHandlers(field == null ? void 0 : field.onBlur, onBlur)
  });
}
export { useFormControl, useFormControlProps };